import fetchTrovePhotos from './fetchTrovePhotos'

export default fetchTrovePhotos
